<template>
  <div class="pageControl">
    <el-pagination
      :total="props.total"
      :page-size="state.pageSize"
      :default-page-size="20"
      :page-sizes="[20, 100, 200, 500, 1000]"
      @current-change="onChangePageIndex"
      layout="total, sizes, prev, pager, next, jumper"
      background
      small
      @size-change="onSizeChange"
      class="page-box"
    />
  </div>
</template>

<script>
import { onMounted, reactive } from "vue";

export default {
  props: {
    total: { type: Number, default: 0 },
    pageIndex: Number,
    pageSize: Number,
  },
  setup(props, { emit }) {
    const state = reactive({});

    onMounted(() => {
      state.pageIndex = props.pageIndex;
      state.pageSize = props.pageSize;
    });

    //分页控件点击事件
    const onChangePageIndex = (pageIndex) => {
      state.pageIndex = pageIndex;

      emit("onLoad", { pageIndex: state.pageIndex, pageSize: state.pageSize });
    };

    const onSizeChange = (pageSize) => {
      state.pageSize = pageSize;
      emit("onLoad", { pageIndex: state.pageIndex, pageSize: state.pageSize });
    };

    return { state, props, onChangePageIndex, onSizeChange };
  },
};
</script>
<style scoped>
.pageControl {
  display: flex;
  align-items: center;
  margin-top: 10px;
}

.pageControl > .el-pagination {
  margin: 0 auto;
  text-align: center;
}
</style>
